import { TokenInfo } from '@/lib/okx-api';

/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2025-07-09 23:44:14
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2025-11-09 12:25:02
 */
import CoImage from '@/components/co-image';
import FilterSearch from '@/components/filter-search';
import { convertChains as chainList } from '@/app/const/chain';
import { convertAddress } from '@/lib/utils';
import CopyText from '../copy';
import './index.scss';

export default function Token(
  props: TokenInfo & {
    hideName?: boolean;
    hideSymbol?: boolean;
    hideAddress?: boolean;
    width?: number;
    height?: number;
    size?: string;
    search?: string;
    className?: string;
    chainId?: string | number;
    hideChain?: boolean;
  }
) {
  // size: xs/sm/base/lg/xl/2xl/
  const {
    width = 28,
    height = 28,
    size = 'sm',
    search = '',
    hideAddress = false,
    hideChain = false,
    hideSymbol = false,
    hideName = true,
    tokenSymbol,
    tokenName,
    tokenLogoUrl,
    tokenContractAddress,
    className,
    chainId,
  } = props;

  // 如果chainId存在，则获取链信息
  const chain = !hideChain && chainId ? chainList.find(c => Number(c.chainId) === Number(chainId)) : null;
  return (
    <div className={`c-token ${className || ''}`}>
      <div className="c-token-logo relative flex-none">
        {tokenLogoUrl && <CoImage src={tokenLogoUrl} alt={tokenName || tokenSymbol} width={width} height={height} className="c-token-logo" />}
        {chain && (
          <div className="absolute -bottom-0 -right-0.5 border rounded-full border-button-border bg-white">
            <CoImage src={chain.img} alt={chain.chainName} width={10} height={10} />
          </div>
        )}
      </div>
      <div className="c-token-info ml-2">
        {!hideSymbol && (
          <div>
            <div className={`line-clamp-1 overflow-hidden break-all text-${size}`}>
              {search ? <FilterSearch text={tokenSymbol} search={search} /> : tokenSymbol}
            </div>
            {!hideName && (
              <div className="line-clamp-1 overflow-hidden break-all text-xs text-[#909090] mt-1" style={{ fontFamily: 'Montserrat Light' }}>
                {tokenName}
              </div>
            )}
          </div>
        )}
        {!hideAddress && (
          <div className={`c-token-info-address text-[#909090] text-${size} flex items-center gap-2`}>
            <span>{convertAddress({ str: tokenContractAddress })}</span>
            {tokenContractAddress && <CopyText text={tokenContractAddress} color="#909090" />}
          </div>
        )}
      </div>
    </div>
  );
}
